module.exports = __webpack_public_path__ + "img/txocLogoHorizontal_white.f573aca0.svg";